module.exports = "ul {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\nli {\r\n    display: inline-block;\r\n    padding: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/tag-list/tag-list.component.css
// module id = ./src/app/tags/tag-list/tag-list.component.css
// module chunks = main